import FeathersHelper from "../../helpers/feathers";

export const find = (payload) =>
  FeathersHelper.find('audiences', payload);
export const create = (payload) =>
  FeathersHelper.create('audiences', payload);
export const patch = (id, payload, params = {}) => FeathersHelper.patch('audiences', id, payload, params);
export const remove = (id, params = {}) => FeathersHelper.remove('audiences', id, params);

